import { debounceTime, distinctUntilChanged, fromEvent } from 'rxjs';

let pluginName = 'ViewportLogging',
	defaults = {};

function ViewportLogging(element, options) {
	this.element = $(element);
	this.options = $.extend({}, defaults, options);

	this._defaults = defaults;
	this._name = pluginName;

	this.init();
}

ViewportLogging.prototype = {
	init: function () {
		this.initialSendViewport();
		this.addEventListener();
	},

	initialSendViewport: function () {
		this.sendLog(this.calculateViewportAndScreen());
	},

	addEventListener: function () {
		let windowResizeObservable = fromEvent(window, 'resize')
			.pipe(
				debounceTime(1500),
				distinctUntilChanged(),
			);
		windowResizeObservable.subscribe(function () {
			this.sendLog(this.calculateViewportAndScreen());
		}.bind(this));
	},

	calculateViewportAndScreen: function () {
		let $window = $(window);

		//clientside logging currently doesn't allow nested objects. That's why all information must be written in one area
		return {
			viewport_height: $window.height(),
			viewport_width: $window.width(),
			screen_height: window.screen.height,
			screen_width: window.screen.width,
		};
	},

	sendLog: function (calculatedViewportAndScreen) {
		window.logRemoteInfo('screensize', calculatedViewportAndScreen);
	},
};

$.fn[pluginName] = function (options) {
	return this.each(function () {
		if (!$.data(this, 'plugin_' + pluginName)) {
			$.data(this, 'plugin_' + pluginName, new ViewportLogging(this, options));
		}
	});
};
